module.exports = __webpack_public_path__ + "img/menu_play_blu@3x.4077bfcf.png";